var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 24C9.62217 24 9.30573 23.872 9.05062 23.616C8.79551 23.36 8.6675 23.0436 8.66662 22.6667V20H26V8H28.6666C29.0444 8 29.3613 8.128 29.6173 8.384C29.8733 8.64 30.0008 8.95644 30 9.33333V29.3333L24.6666 24H9.99995ZM3.33328 22.6667V4C3.33328 3.62222 3.46128 3.30578 3.71728 3.05066C3.97328 2.79555 4.28973 2.66755 4.66662 2.66666H22C22.3777 2.66666 22.6946 2.79466 22.9506 3.05066C23.2066 3.30666 23.3342 3.62311 23.3333 4V16C23.3333 16.3778 23.2053 16.6947 22.9493 16.9507C22.6933 17.2067 22.3768 17.3342 22 17.3333H8.66662L3.33328 22.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.d8a703ccd4ab2f922623324f6e28147e.svg";
export { ForwardRef as ReactComponent };